import React, { useState } from 'react'
import { Row, Col, Icon, Uploader } from 'rsuite'
import CenterChangeFormAttach from './CenterChangeFormAttach'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import { useForm } from 'react-hook-form/dist/index.ie11'
import { Controller } from 'react-hook-form'
import { isImageOrPdf, isValidators } from '../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'

export default function CenterChangeFormContractCenterAttach({
  schema,
  onDownload = () => {},
  onPreview = () => {},
  onDelete = () => {},
  onAddOrDelFile = () => {},
  ...props
}) {
  const [uploadfileList, setUploadfileList] = useState()

  const [attachFiles, setAttachFiles] = useState(schema.attachFiles)

  const [isRefash, setIsRefash] = useState(false)

  const defaultMaxFileSize = 5

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const onSubmit = (data) => {
    // console.log('data', data)
    // console.log('tableSelected => ', tableSelected)
    let attachs = cloneDeep(attachFiles)

    let file = data[schema.attach.name][0]

    let val = {
      contractFileTypeId: data[schema.attachType.name],
      contractFileType: schema.attachType.options?.find(
        (e) => e.value == data[schema.attachType.name]
      ).label,
      enableDelete: true,
      label: file.name,
      name: file.name,
      file: file,
    }

    if (attachs?.value?.length > 0) {
      attachs.value.push(val)
    } else {
      attachs.value = [val]
    }

    onAddOrDelFile(attachs.value?.filter((e) => isEmpty(e.id)))

    setAttachFiles(attachs)
    onClearData()
  }

  const onDeleteFile = (data, index) => {
    let attachs = cloneDeep(attachFiles)
    if (data.id) {
      onDelete(data.id)
    }

    attachs.value.splice(index, 1)

    onAddOrDelFile(attachs.value?.filter((e) => !isEmpty(e.id)))

    setAttachFiles(attachs)
  }

  const onClearData = () => {
    setValue(schema.attach.name, undefined)
    setValue(schema.attachType.name, undefined)
    setUploadfileList(undefined)
    onRefash()
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      <Row style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 20 }}>
          <b style={{ marginTop: 20 }}>{schema.header}</b>
        </Col>
        {!isRefash && (
          <>
            {errors[schema.attach.name] && (
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.attach.name]} />
              </Col>
            )}
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <Controller
                key={schema.attach.name}
                name={schema.attach.name}
                control={control}
                rules={isValidators(schema.attach.validators)}
                defaultValue={uploadfileList}
                render={(props) => {
                  return (
                    <Uploader
                      accept=".jpg, .jpeg, .png, .pdf"
                      autoUpload={false}
                      listType="picture-text"
                      draggable
                      fileList={uploadfileList}
                      onChange={(files) => {
                        if (files?.length < 1) {
                          props.onChange(undefined)
                          setUploadfileList([])
                        } else {
                          let file = files[files.length - 1]
                          console.log(file)

                          if (
                            file.blobFile.size >
                            (schema?.attach?.fileSize || defaultMaxFileSize) * 1024 * 1024
                          ) {
                            notification.open('error', {
                              title: `ขนาดไฟล์เกิน ${
                                schema.attach.fileSize || defaultMaxFileSize
                              } MB`,
                              duration: 5000,
                            })
                            return
                          }

                          if (!file || isImageOrPdf(file.blobFile.type)) {
                            props.onChange([file])
                            setUploadfileList([file])
                          } else {
                            props.onChange(uploadfileList)
                            setUploadfileList(uploadfileList)
                            notification.open('error', {
                              title: `อัพโหลดไฟล์เป็นรูปภาพหรือ PDF เท่านั้น *** ชนิดที่รองรับ png , jpeg , jpg , pdf ***`,
                              duration: 5000,
                            })
                          }
                        }
                      }}
                    >
                      <div style={{ lineHeight: '100px' }}>
                        <Icon size="4x" icon="upload2" />
                        <small
                          style={{
                            marginTop: '-70px',
                            display: 'block',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ png , jpeg , jpg
                          , pdf ขนาดไม่เกิน {schema?.attach?.fileSize || defaultMaxFileSize} MB
                        </small>
                      </div>
                    </Uploader>
                  )
                }}
              />

              <InputSelectForm
                schema={schema.attachType}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                // searchable={false}
                // onChange={(value) => {
                //   // setIsEContract(value == 2)
                // }}
              />
            </Col>
          </>
        )}
      </Row>
      <Row style={{ textAlign: 'right', marginTop: 10 }}>
        <SaveButton icon="plus" onClick={handleSubmit(onSubmit)} children="เพิ่ม" />
        <CancelButton
          onClick={() => {
            onClearData()
          }}
          children="ยกเลิก"
        />
      </Row>

      <CenterChangeFormAttach
        titel=""
        attachFiles={attachFiles}
        isEnableDel
        isView
        // setTableSelected={setTableSelected}
        onDownload={onDownload}
        onPreview={onPreview}
        onDelete={onDeleteFile}
      />
    </>
  )
}
